module.exports = __webpack_public_path__ + "img/sariasihlogo.ddceaaa2.png";